import React from 'react';
import styled from 'styled-components';

import { MonitoringStatusItem } from 'Components/monitoring-status-legend';

const BGCOLOR = 'green';
const LABEL = 'Network';

const Name = styled.span`
  color: var(--gray300);
  font-weight: 600;
`;

export default function StatusLtnNetwork() {
  return (
    <>
      <MonitoringStatusItem circular bgcolor={BGCOLOR} empty size="big" />
      <Name className="ml-1 mr-2">{LABEL}</Name>
    </>
  );
}
